import { Box, Typography, IconButton, Paper, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import Point from '../../assets/svg/Point';
import SquareExclamatioMark from '../../assets/svg/SquareExclamatioMark';
import Clock from '../../assets/svg/Clock';
import Track from '../../assets/svg/Track';
import Graphics from '../../assets/svg/Graphics';
import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter';
import { Slide } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import {
  callStatusColorMatching,
  statusMatching,
} from '../../pages/Incidents/utils/statusMatching';
import { dateTimeFormat } from '../../utils/formatDate';
import { callStatusMatching } from '../../pages/Incidents/utils/callStatusMatching';
import { useSelector } from 'react-redux';
import { statusColorsOutline } from './Map';

const PaperCustom = styled(Paper)(({ theme }) => ({
  '&.MuiPaper-root': {
    position: 'fixed',
    right: 0,
    top: 63,
    bottom: 16,
    width: 575,
    padding: '20px',
    boxShadow: 'none',
    border: '1px solid #E1E1E1',
    borderRadius: '12px 0 0 12px',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 9999,
    overflow: 'auto',
    '& p.sectionTitle': {
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '20px',
      color: '#6B6B6B',
      marginBottom: '12px',
    },
    '& p.subTitle': {
      fontSize: '16px',
      fontWeight: 500,
      color: '#6B6B6B',
    },
    '& p.text': {
      fontSize: '16px',
      fontWeight: 500,
      color: '#000000df',
      marginTop: '7px',
      whiteSpace: 'wrap',
      wordBreak: 'break-all',
    },
  },
}));

const IncidentDetails = ({ incident, onClose }) => {
  const [open, setOpen] = useState(false);

  const { callStatus } = useSelector((state) => state.incidentsReducer);

  useEffect(() => {
    if (incident) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [incident]);

  const nerisStatus = useMemo(
    () => statusMatching(incident?.neris_status),
    [incident]
  );
  const types = useMemo(
    () =>
      !incident
        ? []
        : incident.incident_types?.includes('/')
          ? incident.incident_types.split('/')
          : [incident.incident_types],
    [incident]
  );

  if (!incident) return null;

  return (
    <Slide direction="left" in={open} mountOnEnter unmountOnExit>
      <PaperCustom>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box
            sx={{
              px: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background:
                statusColorsOutline[incident?.status?.toLowerCase()],
              borderRadius: '12px',
              width: 'fit-content',
              height: 'fit-content',
            }}
          >
            <Typography sx={{ fontSize: '28px', fontWeight: 500, mr: 2 }}>
              Incident
            </Typography>
            <Typography sx={{ fontSize: '24px', fontWeight: 300 }}>
              {incident.incident_number}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            borderBottom: '1px solid #E1E1E1',
            pb: 2,
            px: 2,
          }}
        >
          <Typography className="sectionTitle">
            Incident Identification
          </Typography>
          <Stack spacing={2}>
            <Box>
              <Box className="d-flex align-items-center">
                <Clock />
                <Typography className="subTitle ms-1">Dispatch Time</Typography>
              </Box>
              <Typography className="text">
                {' '}
                {dateTimeFormat(incident?.dispatch_time)}
              </Typography>
            </Box>
            <Box>
              <Box className="d-flex align-items-center">
                <SquareExclamatioMark />
                <Typography className="subTitle ms-1">Type</Typography>
              </Box>
              {types
                ? types.map((item, index, arr) => (
                    <Typography className="text" key={item + index}>
                      {item}
                      {arr.length - 1 > index ? ', ' : ''}
                    </Typography>
                  ))
                : '-'}
            </Box>
            <Box>
              <Box className="d-flex align-items-center">
                <Point />
                <Typography className="subTitle ms-1">Address</Typography>
              </Box>
              <Typography className="text">
                {incident?.address || '-'}
              </Typography>
            </Box>
          </Stack>
        </Box>

        <Box
          sx={{
            borderBottom: '1px solid #E1E1E1',
            pb: 2,
            mt: 2,
            px: 2,
          }}
        >
          <Typography className="sectionTitle">Response Units</Typography>
          <Stack spacing={2}>
            <Box>
              <Box className="d-flex align-items-center">
                <Track />
                <Typography className="subTitle ms-1">
                  1st Arriving Unit
                </Typography>
              </Box>
              <Typography className="text">
                {incident.first_arriving_unit}
                {/* {earliestUnit(incident?.unitResponses)} */}
              </Typography>
            </Box>
            <Box>
              <Box className="d-flex align-items-center">
                <Track />
                <Typography className="subTitle ms-1">
                  Additional units
                </Typography>
              </Box>
              <Typography className="text">
                {incident.responded_units}
                {/* {additionalUnits(incident?.unitResponses)} */}
              </Typography>
            </Box>
          </Stack>
        </Box>

        {/* <Box
          sx={{
            borderBottom: '1px solid #E1E1E1',
            pb: 2,
            px: 2,
            mt: 2,
          }}
        >
          <Typography className='sectionTitle'>Personell</Typography>
          <Stack
            direction='row'
            spacing={2}
            useFlexGap
            sx={{
              alignItems: 'center',
            }}
          >
            <Box sx={{ width: '50%' }}>
              <Box className='d-flex align-items-center'>
                <OnePerson />
                <Typography className='subTitle ms-1'>Officer in Charge</Typography>
              </Box>
              <Typography className='text'>Alexander Stevenson</Typography>
            </Box>
            <Box sx={{ width: '50%' }}>
              <Box className='d-flex align-items-center'>
                <TwoPerson />
                <Typography className='subTitle ms-1'>Shift</Typography>
              </Box>

              <Typography className='text'>Day</Typography>
            </Box>
          </Stack>
        </Box> */}

        {/* <Box
          sx={{
            borderBottom: '1px solid #E1E1E1',
            pb: 2,
            mt: 2,
            px: 2,
          }}
        >
          <Typography className='sectionTitle'>Notes</Typography>
          <Box>
            <Typography className='text'>
              6 people are experiencing chest pain. Possible smoke inhalation poisoning
            </Typography>
          </Box>
        </Box> */}

        <Box
          sx={{
            pb: 2,
            mt: 2,
            px: 2,
          }}
        >
          <Typography className="sectionTitle">Status Information</Typography>
          <Stack
            direction="row"
            spacing={2}
            useFlexGap
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={{ width: '50%' }}>
              <Box className="d-flex align-items-center">
                <Graphics />
                <Typography className="subTitle ms-1">Status</Typography>
              </Box>
              <Box
                sx={{
                  background: callStatusColorMatching(
                    incident?.status?.toLowerCase()
                  )?.bg,
                  padding: '5px 15px',
                  borderRadius: '3px',
                  width: 'fit-content',
                  mt: '10px',
                }}
              >
                {incident?.status
                  ? callStatusMatching(callStatus, incident.status)
                  : '-'}
              </Box>
            </Box>
            <Box sx={{ width: '50%' }}>
              <Box className="d-flex align-items-center">
                <Graphics />
                <Typography className="subTitle ms-1">NERIS Status</Typography>
              </Box>
              <Box
                sx={{
                  background: nerisStatus.bg,
                  color: nerisStatus.color,
                  padding: '5px 15px',
                  borderRadius: '999px',
                  width: 'fit-content',
                  mt: '10px',
                }}
              >
                {nerisStatus.text}
              </Box>
            </Box>
          </Stack>
        </Box>
      </PaperCustom>
    </Slide>
  );
};

export default IncidentDetails;
